<template>
  <div class="resume-content" v-if="experience.length > 0">
    <div class="resume-view-section-header">EXPERIENCE</div>
    <div style="" v-if="!noData">
      <div v-bind:key="index" v-for="(work, index) in experience">
        <experience-card :index="index" :job="work"></experience-card>
      </div>
    </div>
    <div style="margin-top: 1rem" v-if="noData">
      <div style="color: #ff5252">
        Seems like you haven't added your experience related information yet!
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceCard from "./experience-cards";
import { SORT_PROFILE_FORMAT2 } from "../../../filters";
export default {
  name: "experience-view",
  components: {
    ExperienceCard,
  },
  props: {
    exp: Array,
  },
  data: function () {
    return {
      experience: [],
      noData: false,
    };
  },
  // methods: {
  //   getUserExperienceInfo: function() {
  //     const self = this;
  //     const token = JSON.parse(localStorage.getItem("token"));
  //     self
  //       .$http({
  //         method: this.$constants.METHOD.GET,
  //         url: this.$constants.BASE_URL.USER_EXPERIENCES_INFO_URL,
  //         headers: {
  //           "content-type": this.$constants.HEADERS.TYPE.APPLICATION_JSON,
  //           Authorization: "Bearer " + token
  //         }
  //       })
  //       .then(function(response) {
  //         if (response.status === 200) {
  //           if (response.data.length > 0) {
  //             self.jobs = SORT_PROFILE_FORMAT2(response.data, "is_working", [
  //               "start_year",
  //               "end_year"
  //             ]);
  //             self.noData = false;
  //           } else {
  //             self.noData = true;
  //           }
  //         } else {
  //           self.noData = true;
  //         }
  //       })
  //       .catch(function() {});
  //   }
  // },
  mounted: function () {
    if (this.exp) {
      this.experience= SORT_PROFILE_FORMAT2(this.exp, "is_working", [
        "start_year",
        "end_year",
      ]);
    }
  },
};
</script>

<style scoped>
.experience-content {
  margin-top: 2rem;
}
.header-text {
  text-align: left;
  background-color: #f7f7f7;
  color: #050505;
}
</style>
